import { useEffect, useState } from "react";
import { TextComponent } from "../../../../core/components/TextComponent";
import { Ubication } from "../../../../core/icons/Ubication";
import SettingComponent from "./SettingComponent";
import { extractCountry } from "../../../profile/presentation/components/ProfilePreview";
import { useSelector } from "react-redux";
import { RootState } from "../../../../core/store/store";
import { useNavigate } from "react-router-dom";
import { getDisplayLocationLabel } from "../../../../core/utilities/locationStorage";
import { CustomButton } from "../../../../core/components/CustomButton";

export const DiscoverySettings = () => {
	const navigate = useNavigate();
	const { user } = useSelector((state: RootState) => state.onboarding);
	const [ubication, setUbication] = useState<string>(getDisplayLocationLabel(user) || extractCountry(user?.city ?? "") || "");
	useEffect(() => {
		setUbication(getDisplayLocationLabel(user) || extractCountry(user?.city ?? "") || "");
	}, [user]);

	return (
		<>
			<TextComponent
				variant="h2"
				className="font-semibold mt-6 mb-5"
			>
				Discovery settings
			</TextComponent>
			<SettingComponent
				icon={<Ubication />}
				title="Search location:"
				children={ubication || " "}
				className="bg-gray-100 select-none hover:bg-gray-200 transition-colors duration-300 ease-in-out"
				onClick={() => navigate("/settings/location")}
			/>
			<p className="mt-2 text-sm text-gray-500">
				{user?.discovery_override_label
					? "Manually chosen search location. Your saved profile location is separate."
					: user?.profile_location_source === "manual_selection"
					? "Using the town you chose manually."
					: user?.profile_location_source === "browser_location"
					? "Using your last saved device location."
					: "Using your saved profile location. Its original source was not recorded."}
			</p>
			<CustomButton color="white" className="mt-3" onClick={() => navigate("/settings/location")}>
				Change location
			</CustomButton>
		</>
	);
};
